/** 提现 */
<template>
  <div class="withdrawal-list-wrap margin-top-20">
    <BasiceLayout
      :title="$t('withdrawal.recordsList.title') "
      class="withdrawal-layout"
      empty-text="loading"
    >
         <el-table
        v-if="withdrawalList !== 'NONE'"
        :data="withdrawalList"
        style="width: 100%;min-height: 200px"
      >
        <el-table-column
          prop="time"
          label="发起时间"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="realMoney"
          label="提现金额"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeBXC"
          label="提现所需BP数量"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="ZFBName"
          label="收款支付宝姓名"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="ZFBAccount"
          label="收款支付宝账号"
          align='center'
        >
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">已提交</span>
            <span v-else-if="scope.row.status === 1">打款完成</span>
            <span v-else-if="scope.row.status === 2">账号错误</span>
            <span v-else-if="scope.row.status === 3">已提交</span>
            <span v-else>已提交</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="withdrawalList === 'NONE'"
        :empty-text="$t('withdrawal.recordsList.noWithdrawalList')"
      ></el-table>
    </BasiceLayout>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "AccountLayout",
  components: {
    BasiceLayout,
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    // withdrawalList: (state) => state.withdrawal.list,
  }),
  data() {
    return {
      withdrawalList: [],
    };
  },
  methods: {
    ...mapActions(["getAutoUserList"]),
  },
  created() {
    this.getAutoUserList().then(res => {
      this.withdrawalList = res.data || []
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus"></style>

